"use strict";
// package: profile
// file: apigateway/profile/blog.proto
exports.__esModule = true;
var apigateway_profile_blog_pb = require("../../apigateway/profile/blog_pb");
var BlogService = /** @class */ (function () {
    function BlogService() {
    }
    BlogService.serviceName = "profile.BlogService";
    return BlogService;
}());
exports.BlogService = BlogService;
(function (BlogService) {
    var GetBlogs = /** @class */ (function () {
        function GetBlogs() {
        }
        GetBlogs.methodName = "GetBlogs";
        GetBlogs.service = BlogService;
        GetBlogs.requestStream = false;
        GetBlogs.responseStream = false;
        GetBlogs.requestType = apigateway_profile_blog_pb.GetBlogsRequest;
        GetBlogs.responseType = apigateway_profile_blog_pb.BlogsReply;
        return GetBlogs;
    }());
    BlogService.GetBlogs = GetBlogs;
    var GetBlog = /** @class */ (function () {
        function GetBlog() {
        }
        GetBlog.methodName = "GetBlog";
        GetBlog.service = BlogService;
        GetBlog.requestStream = false;
        GetBlog.responseStream = false;
        GetBlog.requestType = apigateway_profile_blog_pb.GetBlogRequest;
        GetBlog.responseType = apigateway_profile_blog_pb.BlogReply;
        return GetBlog;
    }());
    BlogService.GetBlog = GetBlog;
    var CreateBlog = /** @class */ (function () {
        function CreateBlog() {
        }
        CreateBlog.methodName = "CreateBlog";
        CreateBlog.service = BlogService;
        CreateBlog.requestStream = false;
        CreateBlog.responseStream = false;
        CreateBlog.requestType = apigateway_profile_blog_pb.CreateBlogRequest;
        CreateBlog.responseType = apigateway_profile_blog_pb.BlogReply;
        return CreateBlog;
    }());
    BlogService.CreateBlog = CreateBlog;
    var UpdateBlog = /** @class */ (function () {
        function UpdateBlog() {
        }
        UpdateBlog.methodName = "UpdateBlog";
        UpdateBlog.service = BlogService;
        UpdateBlog.requestStream = false;
        UpdateBlog.responseStream = false;
        UpdateBlog.requestType = apigateway_profile_blog_pb.UpdateBlogRequest;
        UpdateBlog.responseType = apigateway_profile_blog_pb.BlogReply;
        return UpdateBlog;
    }());
    BlogService.UpdateBlog = UpdateBlog;
    var DeleteBlog = /** @class */ (function () {
        function DeleteBlog() {
        }
        DeleteBlog.methodName = "DeleteBlog";
        DeleteBlog.service = BlogService;
        DeleteBlog.requestStream = false;
        DeleteBlog.responseStream = false;
        DeleteBlog.requestType = apigateway_profile_blog_pb.DeleteBlogRequest;
        DeleteBlog.responseType = apigateway_profile_blog_pb.DeleteBlogReply;
        return DeleteBlog;
    }());
    BlogService.DeleteBlog = DeleteBlog;
    var SearchBlogs = /** @class */ (function () {
        function SearchBlogs() {
        }
        SearchBlogs.methodName = "SearchBlogs";
        SearchBlogs.service = BlogService;
        SearchBlogs.requestStream = false;
        SearchBlogs.responseStream = false;
        SearchBlogs.requestType = apigateway_profile_blog_pb.SearchBlogsRequest;
        SearchBlogs.responseType = apigateway_profile_blog_pb.SearchBlogsReply;
        return SearchBlogs;
    }());
    BlogService.SearchBlogs = SearchBlogs;
    var BlogSitemap = /** @class */ (function () {
        function BlogSitemap() {
        }
        BlogSitemap.methodName = "BlogSitemap";
        BlogSitemap.service = BlogService;
        BlogSitemap.requestStream = false;
        BlogSitemap.responseStream = false;
        BlogSitemap.requestType = apigateway_profile_blog_pb.BlogSitemapRequest;
        BlogSitemap.responseType = apigateway_profile_blog_pb.BlogSitemapReply;
        return BlogSitemap;
    }());
    BlogService.BlogSitemap = BlogSitemap;
    var GetIsBlogger = /** @class */ (function () {
        function GetIsBlogger() {
        }
        GetIsBlogger.methodName = "GetIsBlogger";
        GetIsBlogger.service = BlogService;
        GetIsBlogger.requestStream = false;
        GetIsBlogger.responseStream = false;
        GetIsBlogger.requestType = apigateway_profile_blog_pb.GetIsBloggerRequest;
        GetIsBlogger.responseType = apigateway_profile_blog_pb.GetIsBloggerReply;
        return GetIsBlogger;
    }());
    BlogService.GetIsBlogger = GetIsBlogger;
})(BlogService = exports.BlogService || (exports.BlogService = {}));
exports.BlogService = BlogService;
